define('views/shop/travel/hotels',[
	'backbone',
	'views/_base/baseview',
	'text!views/shop/travel/hotels.html'
], function(Backbone, BaseView, Template){
	'use strict';

	return BaseView.extend({
		className: 'shop-hotels-container',
		tagName  : 'div',
		isRender : false,
		needsAuth: true,
		template : _.template(Template),
		events   : {
			'click .js-shop-hotels-btn' : 'goToShopHotels',
		},
		initialize: function(options){
			options = options || {};

			this.ecard = options.ecard;
			this.parent_view = options.parent_view;

			this.elementName = options.elementName;

			BaseView.prototype.initialize(this);
		},

		render: function(){

			this.$el.html(this.template());
			
		},

		loadData: function(){
			this.render();
		},

		goToShopHotels: function(){
			var url = (pf.envName == '') ? 'https://secure.rezserver.com/ivm/inbound/?refid=7910&mk=1dff48669b3a4a60cf70bdf28b8ccba89342239bffbf4332f125f548f7865a45157a40709b512032&refclickid=' + pf.session.get('UserGUID') : 'https://secure.rezserver.com/ivm/inbound/?refid=7910&mk=1dff48669b3a4a60cf70bdf28b8ccba89342239bffbf4332f125f548f7865a45157a40709b512032&refclickid=' + pf.session.get('UserGUID');
			window.open(url);
		},

		close: function(){}
	});
});
